/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import useCajaApi from "../../../api/reportes/useCajaApi";

const NominaDatosBancarios = ({ solicitudDeGastos }) => {
    const api = useCajaApi();
    const [datosBancarios, setDatosBancarios] = useState(null);

    const empleadoId = solicitudDeGastos?.destinatario?.id;

    useEffect(() => {
        cargarDatosBancarios();
    }, [empleadoId]);

    const cargarDatosBancarios = async () => {
        if (!empleadoId) {
            setDatosBancarios(null);
            return;
        }

        const result = await api.cuentasBancarias(empleadoId);
        setDatosBancarios(result ?? null);
    };

    if (!empleadoId) {
        return (
            <div className="form-row">
                <h5 className="col-12">Datos Bancarios</h5>
                <div className="col-12">
                    Selecciona un destinatario para consultar sus datos bancarios.
                </div>
            </div>
        );
    }

    if (!datosBancarios) {
        return (
            <div className="form-row">
                <h5 className="col-12">Datos Bancarios</h5>
                <div className="col-12">
                    El destinatario no tiene datos bancarios registrados.
                </div>
            </div>
        );
    }

    return (
        <div className="form-row">
            <h5 className="col-12">Datos Bancarios</h5>

            <div className="form-group col-md-6 col-sm-12">
                <label>Banco</label>
                <input className="form-control" value={datosBancarios.banco?.nombre ?? ""} disabled />
            </div>

            <div className="form-group col-md-6 col-sm-12">
                <label>No. Tarjeta</label>
                <input className="form-control" value={datosBancarios.numeroTarjeta ?? ""} disabled />
            </div>

            <div className="form-group col-md-6 col-sm-12">
                <label>No. Cuenta</label>
                <input className="form-control" value={datosBancarios.numeroCuenta ?? ""} disabled />
            </div>

            <div className="form-group col-md-6 col-sm-12">
                <label>CLABE</label>
                <input className="form-control" value={datosBancarios.clabe ?? ""} disabled />
            </div>

            <h5 className="col-12">Otra Información Bancaria</h5>

            <div className="form-group col-md-6 col-sm-12">
                <label>Banco</label>
                <input className="form-control" value={datosBancarios.bancoSeg?.nombre ?? ""} disabled />
            </div>

            <div className="form-group col-md-6 col-sm-12">
                <label>No. Tarjeta</label>
                <input className="form-control" value={datosBancarios.numeroTarjetaSeg ?? ""} disabled />
            </div>

            <div className="form-group col-md-6 col-sm-12">
                <label>No. Cuenta</label>
                <input className="form-control" value={datosBancarios.numeroCuentaSeg ?? ""} disabled />
            </div>

            <div className="form-group col-md-6 col-sm-12">
                <label>CLABE</label>
                <input className="form-control" value={datosBancarios.clabeSeg ?? ""} disabled />
            </div>
        </div>
    );
};

export default NominaDatosBancarios;